import {WorldToLocalRotationConverter} from './WorldToLocalRotationConverter';
import {ObjectWorldTransform} from './ObjectWorldTransform';

export class TransformationQueue {

  private objectTransformations: Array<ObjectWorldTransform> = [];
  private worldToLocalRotationConverter = new WorldToLocalRotationConverter();

  add(transformation: ObjectWorldTransform) {
    this.objectTransformations.push(transformation);
  }

  apply(objects) {
    let transformation, rotation, position;
    objects.forEach((object, index) => {
      transformation = this.objectTransformations[index];
      position = object.parent.worldToLocal(transformation.position);
      rotation = this.worldToLocalRotationConverter.convert(
        transformation.rotation,
        object.parent
      );
      object.position.copy(position);
      object.quaternion.copy(rotation);
    });
    this.objectTransformations.length = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/TransformationQueue.ts